export default function Contact() {
  return (
    <div className="min-h-screen bg-[#000000] py-12 px-6 md:px-20">
      <h2 className="text-3xl font-bold text-white text-center mb-10">
        Contact Me
      </h2>

      <div className="max-w-3xl mx-auto bg-[#000000] p-8 rounded-lg shadow-md">
        <p className="text-lg text-white mb-4">
          Feel free to reach out to me for job opportunities, collaborations, or
          any questions!
        </p>

        <div className="space-y-4 text-gray-800">
          <div>
            <span className="font-semibold">📧 Email:</span>
            <a
              href="mailto:arisradad2003@gmail.com"
              className="text-white hover:underline"
            >
              arisradad2003@gmail.com
            </a>
          </div>

          <div>
            <span className="font-semibold">📱 Phone:</span>
            <a href="tel:+91 7010052849" className="text-white hover:underline">
              +91 7010052849
            </a>
          </div>

          <div>
            <span className="font-semibold">💼 LinkedIn:</span>
            <a
              href="https://linkedin.com/in/arisrada-d-26890b24a"
              target="_blank"
              rel="noreferrer"
              className="text-white hover:underline"
            >
              linkedin.com/in/arisrada-d
            </a>
          </div>

          <div>
            <span className="font-semibold">💻 GitHub:</span>
            <a
              href="https://github.com/arisrada"
              target="_blank"
              rel="noreferrer"
              className="text-white hover:underline"
            >
              github.com/arisrada
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
